import React, { Component } from 'react';
import { Col, Form, NavLink } from 'reactstrap';
import { connect } from 'react-redux';
import { DisplayPayBtnText, RenderForm, GoBack, Timer } from 'components/Common';
import { callSetPayment, callCardMetaDataAPI, callGetTxnStatus } from 'actions/payment';
import GlobalLoaderModal from "components/FDModal/global-loader";
import GlobalErrorModal from "components/FDModal/global-error";
import FPConfig from 'lib/config';
import BHIM_UPI_Image from 'assets/images/bhim.png';
import GPAY_UPI_Image from 'assets/images/google-paya.jpeg';
import PHONEPAY_UPI_Image from 'assets/images/phonepay.jpg';
import PAYTM_UPI_Image from 'assets/images/paytm.png';

class BharatQR extends Component {

	state = {
		clearGetStatusInterval: 'getStatusInterval',
		bharatQrString: null,
		loader: false,
		qrScanComplete: false,
		qrScanSuccess: false,
		cancelTransactionTrigger: false,
		ismanualCheckInProgress: false
	}
	vpa_data;
	attemptCount = 0;
	manualattemptCount = 0
	// ismanualCheckInProgress = false;

	cancelTransaction = this.cancelTransaction.bind(this);
	getManuallyTxnStatus = this.getManuallyTxnStatus.bind(this);
	async componentDidMount() {
		if(this.props.bharathQRData){
			let vpaData = { payload : { data : this.props.bharathQRData } }
			this.vpa_data = vpaData
			this.setPaymentSuccess(this.props.bharathQRData)
		} else {
			this.setState({ loader: true })
			await callCardMetaDataAPI('BHARATQR', null)
			this.props.callSetPayment('BHARATQR', null, this.props.txnKey, this.props.txnIv).then((vpa_data) => {
				this.vpa_data = vpa_data;
				let { errorMessage, bharatQrString } = vpa_data.payload.data
				if (errorMessage) {
					if (!vpa_data.payload.data.redirectUrl)
						this.setState({ loader: false })
				} else if (bharatQrString) {
						this.setPaymentSuccess(vpa_data.payload.data)
				}
			})
		}
	}

	setPaymentSuccess(data){
		let { getTxnStatus, getTxnStatusRequestBean, bharatQrString } = data

		// For Serializing this object
		var search_params = new URLSearchParams();
		search_params.append('cht', 'qr');
		search_params.append('choe', 'UTF-8');
		search_params.append('chs', '300x300');
		search_params.append('chl', bharatQrString);
		const url = `${process.env.REACT_APP_BASE_SERVICE_API_URL}/qrImage?${search_params.toString()}`;
		this.setState({ bharatQrUrl: url })

		if (getTxnStatus) {
			let attemptCount = 0
			let timeout = FPConfig.bqrTimeout.getTxnStatus / 10
			this.getStatusInterval = setInterval(async () => {
				try {
					attemptCount += 1;
					this.attemptCount = attemptCount;
					getTxnStatusRequestBean = { ...getTxnStatusRequestBean, inquiryNo: attemptCount };
					const res = await callGetTxnStatus(getTxnStatusRequestBean);
					if (!this.state.ismanualCheckInProgress) {
						const { transactionStatus, redirectToRetryPayPage } = res.payload;
						this.setState({ txnStatus: res.payload });
						if (this.state.cancelTransactionTrigger) {
							clearInterval(this.getStatusInterval);
							this.setState({
								redirectToRetryPayPage: true,
								loader: false,
								qrScanComplete: true,
								qrScanSuccess: false,
								txnStatus: { transactionStatus: "FAILED", userCancelled: true }
							});
						}
						else if (transactionStatus === "SUCCESS") {
							clearInterval(this.getStatusInterval)
							// document.BHARATQR_SCANForm.submit()

							this.setState({ ismanualCheckInProgress: true, redirectToRetryPayPage, loader: false, qrScanComplete: true, qrScanSuccess: true });
						} else if (transactionStatus === "FAILED") {
							clearInterval(this.getStatusInterval);
							this.setState({ismanualCheckInProgress: true, transactionStatus: "FAILED", redirectToRetryPayPage, loader: false, qrScanComplete: true, qrScanSuccess: false });
							// document.BHARATQR_SCANForm.submit()
						} else if (attemptCount >= timeout) {
							clearInterval(this.getStatusInterval)
							// if(redirectToRetryPayPage){ // Retry count should be configurable from merchant							
							// 	this.setState({redirectToRetryPayPage, loader: false , qrScanComplete:true,qrScanSuccess:false})
							// } else {				
							// 	document.BHARATQR_SCANForm.submit()
							// }
							this.setState({ismanualCheckInProgress: true, transactionStatus: transactionStatus, redirectToRetryPayPage, loader: false, qrScanComplete: true, qrScanSuccess: false });
						} else {
							this.setState({ transactionStatus: transactionStatus });
						}
					}

				} catch (error) {
					if (attemptCount >= timeout) {
						clearInterval(this.getStatusInterval)
						// if(redirectToRetryPayPage){ // Retry count should be configurable from merchant							
						// 	this.setState({redirectToRetryPayPage, loader: false , qrScanComplete:true,qrScanSuccess:false})
						// } else {				
						// 	document.BHARATQR_SCANForm.submit()
						// }
						this.setState({
							redirectToRetryPayPage: true,
							loader: false,
							qrScanComplete: true,
							qrScanSuccess: false,
							txnStatus: { transactionStatus: "FAILED" }
						});
					}

				}
			}, 10000)
		}		
	}

	componentWillUnmount() {
		clearInterval(this.getStatusInterval)
	}

	cancelTransaction() {
		this.setState({
			cancelTransactionTrigger: true
		})
	}

	async getManuallyTxnStatus() {
		console.log(this.vpa_data)
		if (!this.state.ismanualCheckInProgress) {
			let { getTxnStatus, getTxnStatusRequestBean, errorMessage, bharatQrString } = this.vpa_data.payload.data;
			this.manualattemptCount = this.manualattemptCount > 0.7 ? 0.1 :  parseFloat(this.manualattemptCount + 0.1)
			let attemptCount = parseFloat(this.attemptCount + this.manualattemptCount);
			this.setState({ ismanualCheckInProgress: true })
			let vpa_data = this.vpa_data;

			if (errorMessage) {
				if (!vpa_data.payload.data.redirectUrl)
					this.setState({ loader: false })
			} else if (bharatQrString) {
				// For Serializing this object

				if (getTxnStatus) {
					try {
						getTxnStatusRequestBean = { ...getTxnStatusRequestBean, inquiryNo: attemptCount };
						const res = await callGetTxnStatus(getTxnStatusRequestBean);
						const { transactionStatus, redirectToRetryPayPage } = res.payload;
						this.setState({ txnStatus: res.payload });
						if (this.state.cancelTransactionTrigger) {
							clearInterval(this.getStatusInterval);
							this.setState({
								redirectToRetryPayPage: true,
								loader: false,
								qrScanComplete: true,
								qrScanSuccess: false,
								txnStatus: { transactionStatus: "FAILED", userCancelled: true }
							});
						}
						else if (transactionStatus === "SUCCESS") {
							clearInterval(this.getStatusInterval)
							// document.BHARATQR_SCANForm.submit()
							this.setState({ismanualCheckInProgress: true, transactionStatus: "SUCCESS", redirectToRetryPayPage, loader: false, qrScanComplete: true, qrScanSuccess: true });
						} else if (transactionStatus === "FAILED") {
							clearInterval(this.getStatusInterval);
							this.setState({ismanualCheckInProgress: true, transactionStatus: "FAILED", redirectToRetryPayPage, loader: false, qrScanComplete: true, qrScanSuccess: false });
							// document.BHARATQR_SCANForm.submit()
						} else {
							this.setState({ transactionStatus: transactionStatus })
						}
					} catch (error) {

					} finally {
						this.setState({ ismanualCheckInProgress: false })
					}
				}
			}
		}

	}

	render() {
		const { t } = this.props
		const timeout = FPConfig.bqrTimeout.getTxnStatus

		if (!this.state.bharatQrUrl) {
			return (
				this.state.loader && <GlobalLoaderModal transaction={false} />
			)
		}

		return (
			<Col xs="12">
				<div className="card-details-panel d-flex justify-content-center">
					<Form>
						<figure className="text-center">
							<img src={this.state.bharatQrUrl} alt="card" title="" />
							{this.state.bharatQrUrl && <Timer secondsRemaining={timeout} />}
						</figure>
						{this.state.bharatQrUrl &&
							<div className="go-back-site text-center">
								<p>{t('get_bqr_status_title')}</p>
								{!this.state.ismanualCheckInProgress &&
								<>
								<p onClick={this.getManuallyTxnStatus}><NavLink title={t('get_bqr_status_title')} >
										{t('get_bqr_status')}
									</NavLink></p>
								<div className={"text-center " + (this.state.transactionStatus == "AWAITED" ? "statusAwait" : "statusFailed")}>
									<p > {this.state.transactionStatus}</p>
								</div>
								</>
									
								}
								{this.state.ismanualCheckInProgress &&
								<>
								<p ><NavLink title={t('get_bqr_status_loading_title')} >
										{t('get_bqr_status_loading')}
									</NavLink></p>
								</>
									
								}
								
							</div>
						}



						<p className="qrTest text-center">{t('scan_note')} </p>
						<div className="container-fluid upi_image_row">
							<div className="row">
								<div className="col">
									<figure className="text-center mb-4">
										<img className="img-response" src={BHIM_UPI_Image} alt="card" title="" />
									</figure>
								</div>
								<div className="col">
									<figure className="text-center mb-4">
										<img className="img-response" src={GPAY_UPI_Image} alt="card" title="" />
									</figure>
								</div>
								<div className="col">
									<figure className="text-center mb-4">
										<img className="img-response" src={PHONEPAY_UPI_Image} alt="card" title="" />
									</figure>
								</div>
								<div className="col">
									<figure className="text-center mb-4">
										<img className="img-response" src={PAYTM_UPI_Image} alt="card" title="" />
									</figure>
								</div>
							</div>

						</div>
						<p className="error text-center ml-1 mr-1">({t(('bharatQR_note'))})</p>
						<div className="bharat-transBtn mb-3">
							<DisplayPayBtnText labelName='TOTAL' transactionDetails={this.props.transactionDetails} t={this.props.t} />
						</div>
						{!this.state.cancelTransactionTrigger && <div onClick={this.cancelTransaction} className="go-back-site text-center">
							<p><NavLink title={t('go_back_to_2')} >
								{t('cancel_transaction')}
							</NavLink></p>
						</div>
						}{this.state.cancelTransactionTrigger &&
							<a>Cancel transaction in progress </a>
						}
					</Form>
				</div>
				{/* {this.state.redirectToRetryPayPage && <GlobalErrorModal retryBtn={true} />} */}
				{this.state.qrScanSuccess && this.state.qrScanComplete &&
					<RenderForm className='hidden' sessionID={this.props.SessionToken} nbRespURL={this.state.txnStatus.merchantRedirectUrl}
						bharatTxnStatus={this.state.txnStatus} formName="BHARATQR" />
				}
				{!this.state.qrScanSuccess && this.state.qrScanComplete &&
					<RenderForm className='hidden' sessionID={this.props.SessionToken} nbRespURL={FPConfig.qr_failure}
						bharatTxnStatus={this.state.txnStatus} formName="BHARATQR" />
				}

			</Col>
		);
	}
}

const mapStateToProps = state => {
	const { transactionDetails, txnKey, txnIv, SessionToken, termsStatus, bharathQRData } = state.fdData
	let returnProps = { termsStatus, transactionDetails, txnKey, txnIv, SessionToken, bharathQRData }
	return { ...returnProps }
}

export default connect(mapStateToProps, { callSetPayment })(BharatQR);